import { Component } from '@angular/core';

import { Router } from '@angular/router';

interface Destinatario {
  tipo: string;
  destinatario: string;
  descripcion: string;
  activo: boolean;
  horario: string;
  fechaCreacion: string;
  creadoPor: string;
}

@Component({
  selector: 'app-gestion-destinatario',
  templateUrl: './gestion-destinatario.component.html',
  styleUrls: ['./gestion-destinatario.component.scss']
})
export class GestionDestinatarioComponent {
  destinatarios: Destinatario[] = [
    {
      tipo: 'Chat',
      destinatario: 'DEC_AFONASA_CHAT',
      descripcion: 'Sí',
      activo: true,
      horario: '09:15 - 16:30',
      fechaCreacion: '26/07/2024',
      creadoPor: 'mriveramzri'
    },
    {
      tipo: 'Email',
      destinatario: 'consultasAfyP',
      descripcion: 'consultasAfyP@bps.net',
      activo: true,
      horario: '',
      fechaCreacion: '26/07/2024',
      creadoPor: 'mriveramzri'
    }
  ];

  myOptions = [
    { label: 'Todos', value: 'todos' },
    { label: 'Email', value: 'email' },
    { label: 'Chat', value: 'chat' },
  ];

  onSelected(selectedValue: any) {
    //TO DO: Borrar console log
    console.log('seleccionado:', selectedValue);
  }

  constructor(private router: Router) {}

  editDestinatario(destinatario: Destinatario) {
    this.router.navigate(['/editar-destinatario', destinatario.destinatario]);
  }
  

  newDestinatario() {
    this.router.navigate(['/editar-destinatario', '']);
  }

  deleteDestinatario(index: number) {
    this.destinatarios.splice(index, 1);
  }
}
